
import React, {useState, useEffect} from 'react';
import DataTable from 'react-data-table-component';

import { styled, alpha } from '@mui/material/styles';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import EditIcon from '@mui/icons-material/Edit';
import Divider from '@mui/material/Divider';
import ArchiveIcon from '@mui/icons-material/Archive';
import FileCopyIcon from '@mui/icons-material/FileCopy';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import Checkbox from '@mui/material/Checkbox';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';

const label = { inputProps: { 'aria-label': 'Toggle All Columns', 'label': 'toggle' } };

const paginationComponentOptions = {
  rowsPerPageText: 'Display Per Page',
  rangeSeparatorText: 'of',
  selectAllRowsItem: false,
  selectAllRowsItemText: 'All',
};

const StyledMenu = styled((props) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'right',
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'right',
    }}
    {...props}
  />
))(({ theme }) => ({
  '& .MuiPaper-root': {
    borderRadius: 6,
    marginTop: theme.spacing(1),
    minWidth: 180,
    color:
      theme.palette.mode === 'light' ? 'rgb(55, 65, 81)' : theme.palette.grey[300],
    boxShadow:
      'rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px',
    '& .MuiMenu-list': {
      padding: '4px 0',
    },
    '& .MuiMenuItem-root': {
      '& .MuiSvgIcon-root': {
        fontSize: 18,
        color: theme.palette.text.secondary,
        marginRight: theme.spacing(1.5),
      },
      '&:active': {
        backgroundColor: alpha(
          theme.palette.primary.main,
          theme.palette.action.selectedOpacity,
        ),
      },
      '& .MuiCheckbox-root': {
        paddingTop: 0,
        paddingBottom: 0,
      },
      '& .MuiTypography-root': {
        fontFamily: "'Lato', sans-serif",
      }
    },    
  },
}));

  
function Table(props) {
  const [paginationPerPage, setPaginationPerPage] = useState(10)
  const [data, setData] = useState([])
  const [seed, setSeed] = useState(1);

  // Hide/show columns
  const [toggleAll, setToggleAll] = useState(true);
  
  const [columnOptions, setColumnOptions] = useState({
    hideCompany: false,
    hideName: false,
    hideTech: false,
    hideEvent: false,
    hideState: false,
    hideIC: false,
    hideWebsite: false
  });

  const [columns, setColumns] = useState(
    [
      {
        name: 'Company Name',
        omit: false,
        omitOption: 'hideCompany',
        isMenuDisabled: false,
        selector: row => row.title,
        sortable: true,
        cell: row => (
            <a href={row.link} target="_blank" rel="noopener noreferrer">
            {row.title}
            </a>		
        ),
        minWidth: '200px'
      },
      {
        name: 'Showcase Events',
        omit: false,
        omitOption: 'hideEvent',
        isMenuDisabled: false,
        selector: row => row.eventsToString ? row.eventsToString.join(", ") : row.eventsToString,
        sortable: true,
        wrap: true
      },
      {
        name: 'Technology',
        omit: false,
        omitOption: 'hideTech',
        isMenuDisabled: false,
        selector: row => row.technology_type,
        sortable: true,
      },
      {
        name: 'State',
        omit: false,
        omitOption: 'hideState',
        isMenuDisabled: false,
        selector: row => row.state,
        sortable: true,
        maxWidth: '30px'
      },
      {
        name: 'Funding From',
        omit: false,
        omitOption: 'hideIC',
        isMenuDisabled: false,
        selector: row => row.funding_from,
        sortable: true,
        wrap: true
      },
      {
        name: 'Contact Name',
        omit: false,
        omitOption: 'hideName',
        isMenuDisabled: false,
        selector: row => row.contact_name,
        sortable: false,
      },  
      {
        name: 'Website',
        omit: false,
        omitOption: 'hideWebsite',
        isMenuDisabled: false,
        selector: row => row.website,
        sortable: false,
        cell: row => (
          <a href={row.website} target="_blank" rel="noopener noreferrer">
          {row.website}
          </a>		
        ),
      },
    ]
  );

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  

   
  /*
  useEffect(() => {
    console.log(columns)
  }, [columns])
  */

  useEffect(() => {
    setPaginationPerPage(props.paginationPerPage)
    setSeed(Math.random());
  }, [props.paginationPerPage])

  useEffect(() => {
    setData(props.companies)
  }, [props.companies])
  

  const toggleAllColumns = (e) => {
    setToggleAll(!toggleAll)

    //let object = enableMenuOption(columns)

    if (e.target.checked) {
      const newState = columns.map( (col, index) => {
        if (col.omit) {
          return {...col, omit: false};
        }

        if (col.isMenuDisabled) {
          return {...col, isMenuDisabled: false};
        }
  
        // Otherwise return object as is
        return col;
      });
      setColumns(newState)
    } else {
      const newState = columns.map( (col, index) => {
        if (index === 0) {
          return {...col, omit: false, isMenuDisabled: true};
        } else {
          return {...col, omit: true, isMenuDisabled: false};
        }
      });
      setColumns(newState)
    }
  }

  
  const handleCheckboxChange = (e, idx) => {
    
    let object = columns.map( (obj, index) => {
      if (index === idx) {
        return {...obj, omit: !e.target.checked};
      }

      // Otherwise return object as is
      return obj;
    });

    const omitted = object.find( ({omit}) => omit === true)

    if (typeof omitted === "undefined") {
      setToggleAll(true)
    } else {
      setToggleAll(false)
    }

    if (isLastItem(object)) {
      object = disableMenuOption(object)
    } else {
      object = enableMenuOption(object)
    }

    const newState = object
    setColumns(newState)    
  }

  const isLastItem = (obj) => {
    let counter = 0;
    obj.forEach((column, idx) => {
      if (!column.omit) {
        counter++;  
      }
    })

    return counter === 1
  }

  const enableMenuOption = (object) => {
    const newState = object.map( (obj, index) => {
      if (obj.isMenuDisabled) {
        return {...obj, isMenuDisabled: false};
      }

      // Otherwise return object as is
      return obj;
    });

    return newState
  }

  const disableMenuOption = (object) => {
    const newState = object.map( (obj, index) => {
      if (!obj.omit) {
        return {...obj, isMenuDisabled: true};
      }

      // Otherwise return object as is
      return obj;
    });

    return newState
  }

  const renderMenu = () => {
    return (
      <div className='adjust-columns'>
        <Button
          id="demo-customized-button"
          aria-controls={open ? 'demo-customized-menu' : undefined}
          aria-haspopup="true"
          aria-expanded={open ? 'true' : undefined}
          variant="contained"
          disableElevation
          onClick={handleClick}
          endIcon={<KeyboardArrowDownIcon />}
        >
          Adjust Columns
        </Button>
        <StyledMenu
          id="demo-customized-menu"
          MenuListProps={{
            'aria-labelledby': 'demo-customized-button',
          }}
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
        >
          <MenuItem disableRipple>
            <FormGroup>
              <FormControlLabel 
                control={<Checkbox checked={toggleAll} />} 
                label="Toggle All Columns" 
                onChange={(e) => toggleAllColumns(e)}/>
            </FormGroup>
          </MenuItem>
          <Divider sx={{ my: 0.5 }} />
          { 
            columns.map( (column, idx) => {
              return (
                <MenuItem disableRipple key={idx}>
                  <FormControlLabel 
                    disabled={column.isMenuDisabled}
                    control={<Checkbox checked={!column.omit} />} 
                    label={column.name} 
                    onChange={(e) => handleCheckboxChange(e, idx)} />
                </MenuItem>
              );
            }) 
          }
        </StyledMenu>
      </div>
    );
  }


  return (
    <div className='table-container'>
      {renderMenu()}
      <DataTable
        key={seed}
        columns={columns}
        data={data}
        pagination
        paginationPerPage={paginationPerPage}
        paginationRowsPerPageOptions={[12, 24, 48, 96]}
        paginat ionComponentOptions={paginationComponentOptions}
        responsive
        subHeaderWrap
        progressPending={props.pending}
        striped={false}
        dense={false}
      />
    </div>

  );
};

export default Table;